import { useTranslation } from "react-i18next";
import ConnectionIndicator from "../serverStatus/ConnectionIndicator";
import NewerBuildNotice from "../serverStatus/NewerBuildNotice";
import { helpArticleOfMatches } from "../features/help/helpArticles";
import HelpMenu from "../features/help/HelpMenu";
import ProjectMenu from "../projects/menu/ProjectMenu";
import AccountMenu from "./AccountMenu";
import { APP_SECTIONS } from "./appSections";
import ReviewInboxBadge from "../features/reviews/inbox/ReviewInboxBadge";
import HostOfferBadge from "../features/threads/hosting/HostOfferBadge";
import TopbarControl from "../ui/buttons/TopbarControl";
import { ROUTE_PATTERNS } from "../shared/routing/appPaths";
import TabSwitcher from "./workspace/tabs/TabSwitcher";
import type { WorkspaceOwner } from "./workspace/useWorkspaceOwner";

/**
 * The one top bar, full width over the sidebar and the tabs (F34, WA-10): the project on the
 * left beside the pinned Threads inbox, and on a narrow screen the list of open tabs;
 * help and the account on the right. Language and theme live in Personal preferences,
 * Administration in the account menu (F14, option A).
 */
export default function TopBar({ owner }: { owner: WorkspaceOwner }) {
  const { t } = useTranslation();
  const InboxIcon = APP_SECTIONS.find(({ id }) => id === "threads")?.icon;

  return (
    <header className="app-topbar relative z-50 flex h-11 shrink-0 items-center gap-2">
      <div className="flex min-w-0 items-center">
        <h1 className="ml-4 text-sm font-semibold">{t("app.title")}</h1>
        <ProjectMenu className="ml-3" />
      </div>
      <div className="flex min-w-0 items-center gap-1">
        <TopbarControl className="relative" onClick={() => { owner.controller.openSection(ROUTE_PATTERNS.threads, false); }}>
          {InboxIcon === undefined ? null : <InboxIcon className="h-4 w-4" aria-hidden="true" />}
          {t("sections.threads")}<HostOfferBadge /><ReviewInboxBadge />
        </TopbarControl>
        {owner.wide ? null : <TabSwitcher controller={owner.controller} />}
      </div>
      <div className="ml-auto flex shrink-0 items-center justify-end">
        <NewerBuildNotice className="mr-1" />
        <ConnectionIndicator className="mr-1" />
        <HelpMenu className="mr-1" article={helpArticleOfMatches(owner.snapshot.activeMatches)} />
        <AccountMenu className="mr-3" />
      </div>
    </header>
  );
}
